import { getTableColumns } from 'helpers';

const AffiliationsHistoryColumns = [
  ['action', 'string', 'Action', 'left', true],
  ['date', 'date', 'Date', 'left', true],
  ['user', 'string', 'User', 'left', true],
  ['registrationType', 'string', 'Registration Type', 'left', true],
  ['rosterOwner', 'string', 'Roster Owner', 'left', true],
  ['psrCode', 'string', 'IRB Type', 'left', true],
  ['countryCode', 'string', 'Country', 'left', true],
  ['siteCtepId', 'string', 'CTEP ID', 'left', true],
  ['esysStatus', 'string', 'Status', 'left', true]
];

export default getTableColumns(AffiliationsHistoryColumns);